interface ViewerErrorProps {
    error: Error | undefined;
    retry: () => void;
}

const ViewerError = ({ error, retry }: ViewerErrorProps) => {
    if (!error) return null;

    return (
        <div role="alert" className="absolute inset-0 z-30 flex flex-col items-center justify-center gap-3 bg-white p-6 text-center">
            <p>Le viewer n’a pas pu démarrer ou son affichage graphique a été interrompu.</p>
            <button type="button" onClick={retry} className="rounded border border-gray-400 px-4 py-2 hover:bg-gray-100">
                Relancer le viewer
            </button>
            <p className="text-sm text-gray-600">Si le problème persiste, fermez cet onglet puis rouvrez l’application.</p>
        </div>
    );
};

export default ViewerError;
